import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedWorkoutListList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

export interface IUseWorkouts {
  search?: string;
  kiloClassTypeId?: string | null;
  start?: string;
  end?: string;
  ordering?: string;
  limit?: string;
}

function useWorkouts({
  search,
  kiloClassTypeId,
  start,
  end,
  ordering = '-date',
  limit = '20',
}: IUseWorkouts = {}): UseInfiniteQueryResult<AxiosResponse<PaginatedWorkoutListList>> {
  const fetchWorkouts = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedWorkoutListList>> => {
      const params: UrlParams = { ...pageParam };

      if (search) {
        params.search = search;
      }

      if (kiloClassTypeId) {
        params.kilo_class_type = kiloClassTypeId;
      }

      if (start) {
        params.start = start;
      }

      if (end) {
        params.end = end;
      }

      if (ordering) {
        params.ordering = ordering;
      }

      return client.get(`workouts/?${encodeUrlParams(params)}`);
    },
    [end, kiloClassTypeId, limit, ordering, search, start],
  );

  return useInfiniteQuery(['workouts', search, kiloClassTypeId, start, end, ordering], fetchWorkouts, {
    getNextPageParam: page => (page.data.next ? urlParamsFromUrl(page.data.next) : undefined),
  });
}

export default useWorkouts;
